module.exports = __webpack_public_path__ + "static/media/7_B.32472da4.png";